/*@license setup-module 3.0.4 SEE LICENSE IN LICENSE.txt *//**
* Setup Component
*/
(function(angular){
  'use strict';

  angular.module('setup-module', ['setup-module.component.templates'])
  .component('setupModule', {
    templateUrl: 'components/setup-module/export/setup-module.html',
    controller: setupModuleCtrl,
    controllerAs: 'vm',
    bindings: {
      companyId: '<',
      contactId: '<',
      lang: '<'
    }
  });

  setupModuleCtrl.$inject = ['$http', '$scope', 'helpService'];

  function setupModuleCtrl($http, $scope, helpService) {

    /*jshint validthis:true */
    var vm = this;
    vm.startSetup = startSetup;
    vm.nextCategory = nextCategory;
    vm.prevCategory = prevCategory;
    vm.markComplete = markComplete;
    vm.resetQuestionairre = resetQuestionairre;
    vm.deleteCompletionPref = deleteCompletionPref;

    this.$onInit = function() {

      getHelpLang();

      // if no questionairre event
      if(!vm.setupData) {
        getSetupPreference().then(function(setupPref) {
          if(setupPref.length > 0) {
            vm.setupData = setupPref[0].value;
          }
        });
      }

      //get preference determining whether each setup step is complete or incomplete
      getCompletionStatus().then(function(completionTracking){
        if (completionTracking.length > 0) {
          vm.completionTrackingPref = completionTracking[0];
          vm.completionTracking = completionTracking[0].value;
        } else {
          vm.completionTracking = {
            permGroups: false,
            rateDesc: false,
            addStaff: false,
            engagementTemplates: false,
            defineActivities: false,
            projectTemplates: false,
            customizeClientCenter: false,
            addClients: false,
            clientEngagements: false,
            folderTemplates: false,
            clientFolders: false,
            uploadDocs: false
          };
        }
      }).catch(function(){
        console.log('unable to get completion tracking');
      });

      //questionairre event
      $scope.$on('bmUpdateCompanyStaffServices', function(event, data){
        vm.setupData = data;
        vm.services = data.service;
      });
      $scope.$on('bmLanguageChangeSuccess', function() {
            getHelpLang();
      });
    };

    var staffCategory = { name: 'Staff', completed: false };
    var workflowCategory = { name: 'Work Flow', completed: false };
    var clientCategory = { name: 'Clients', completed: false };
    var documentCategory = { name: 'Documents', completed: false };

    // simple double linked list
    staffCategory.next = workflowCategory;
    workflowCategory.next = clientCategory;
    workflowCategory.prev = staffCategory;
    clientCategory.next = documentCategory;
    clientCategory.prev = workflowCategory;
    documentCategory.prev = clientCategory;

    function startSetup() {
      vm.selectedCategory = staffCategory;
    }
    function nextCategory() {
      if(vm.selectedCategory.next){
        vm.selectedCategory = vm.selectedCategory.next;
      }
    }
    function prevCategory() {
      if(vm.selectedCategory.prev){
        vm.selectedCategory = vm.selectedCategory.prev;
      }
    }
    function loadHelp() {
      return helpService.load().then(function(resp){
        return resp.data;
      });
    }
    function getHelpLang() {
        loadHelp().then(function(helpData){
          // these help topics only exist for CA-en and CA-fr, default to CA-en, eventually will come from actual oCountry param
          var countryCode = 'ca';
          var langCode = helpData.parameters.oLang;
          vm.lang = countryCode + '-' + langCode;
        });
    }
    function resetQuestionairre(){
      getSetupPreference().then(function(pref){
        deleteSetupPreference(pref[0].id).then(function(){
        }).catch(function(){
          console.log('delete failed');
        });
      }).catch(function(){
        console.log('unable to find pref');
      });
    }
    function deleteCompletionPref() {
      getCompletionStatus().then(function(pref){
        var url = '/api/profiles/v1/preferences/' + pref[0].id;
        return $http({
          method: 'DELETE',
          url: url
        });
      });
    }
    function getSetupPreference() {
      var url = '/api/profiles/v1/companies/' + vm.companyId + '/preferences';
      return $http({
              method: 'GET',
              url: url,
              params: {
                  application: 'onvio',
                  category: 'setupWidget'
              }
          }).then(function(res) {
              return res.data;
          });
    }
    function getCompletionStatus() {
      var url = '/api/profiles/v1/preferences';
      return $http({
              method: 'GET',
              url: url,
              params: {
                  application: 'onvio',
                  category: 'setupCompletion'
              }
          }).then(function(res) {
              return res.data;
          });
    }
    function deleteSetupPreference(prefId) {
      var url = '/api/profiles/v1/companies/' + vm.companyId + '/preferences/' + prefId;
      return $http({
        method: 'DELETE',
        url: url
      });
    }
    function saveCompletionTracking() {
      if(vm.completionTrackingPref){
        updateCompletionTracking();
      } else {
        createCompletionTracking();
      }
    }
    function updateCompletionTracking() {
      var url = '/api/profiles/v1/preferences/' + vm.completionTrackingPref.id;
      return $http({
        method: 'PUT',
        data: vm.completionTrackingPref,
        url: url
      });
    }
    function createCompletionTracking(){
      var pref = {
        application: 'onvio',
        category: 'setupCompletion',
        value: vm.completionTracking
      };
      var url = '/api/profiles/v1/preferences/';
      return $http({
        method: 'POST',
        data: pref,
        url: url
      });
    }
    function markComplete(task) {
      switch(task) {
        case 'permGroups':
          vm.completionTracking.permGroups = true;
          break;
        case 'rateDesc':
          vm.completionTracking.rateDesc = true;
          break;
        case 'addStaff':
          vm.completionTracking.addStaff = true;
          break;
        case 'engagementTemplates':
          vm.completionTracking.engagementTemplates = true;
          break;
        case 'defineActivities':
          vm.completionTracking.defineActivities = true;
          break;
        case 'projectTemplates':
          vm.completionTracking.projectTemplates = true;
          break;
        case 'customizeClientCenter':
          vm.completionTracking.customizeClientCenter = true;
          break;
        case 'addClients':
          vm.completionTracking.addClients = true;
          break;
        case 'clientEngagements':
          vm.completionTracking.clientEngagements = true;
          break;
        case 'folderTemplates':
          vm.completionTracking.folderTemplates = true;
          break;
        case 'clientFolders':
          vm.completionTracking.clientFolders = true;
          break;
        case 'uploadDocs':
          vm.completionTracking.uploadDocs = true;
          break;
      }
      saveCompletionTracking();
    }
  }

})(window.angular);

(function(angular){
  'use strict';

  // TODO: change the template module dependency
  // from 'bluemoon-frontend-seed.component.templates'
  // to '<bowerCfg.name>.component.templates'
  // where <bowerCfg.name> is the value of your name property in bower.json
  angular.module('setup-card', ['setup-module.component.templates'])
  .component('setupCard', {
    templateUrl: 'components/setup-card/export/setup-card.html',
    controller: setupCardCtrl,
    controllerAs: 'vm',
    bindings: {
      card: '<',
      number: '<'
    }
  });

  setupCardCtrl.$inject = [];

  function setupCardCtrl() {
    /*jshint validthis:true */
    var vm = this;
    this.$onInit = function() {
      vm.card = this.card;
      vm.number = this.number;
    };
  }

})(window.angular);

angular.module('setup-module.component.templates', ['components/setup-card/export/setup-card.html', 'components/setup-module/export/setup-module.html']);

angular.module("components/setup-card/export/setup-card.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/setup-card/export/setup-card.html",
    "");
}]);

angular.module("components/setup-module/export/setup-module.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/setup-module/export/setup-module.html",
    "<div id=\"setup-module\">\n" +
    "  <div class=\"module-container\">\n" +
    "    <div class=\"header-container\">\n" +
    "      <h1 class=\"\" translate=\"Setup Guide\"></h1>\n" +
    "      <div class=\"status-indicator\">\n" +
    "        <div class=\"status-container\">\n" +
    "          <div class=\"circle-container\">\n" +
    "            <div class=\"connect-line empty\"></div>\n" +
    "            <div class=\"progress-circle\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Staff', 'selected-empty': vm.selectedCategory.name==='Work Flow' || vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Work Flow' || vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "          </div>\n" +
    "          <div class=\"status-indicator group-name\"  translate=\"Staff\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"status-container\">\n" +
    "          <div class=\"circle-container\">\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Work Flow' || vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"progress-circle\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Work Flow', 'selected-empty': vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "          </div>\n" +
    "          <div class=\"status-indicator group-name\" translate=\"Work Flow\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"status-container\">\n" +
    "          <div class=\"circle-container\">\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Clients' || vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"progress-circle\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Clients', 'selected-empty': vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "          </div>\n" +
    "          <div class=\"status-indicator group-name\" translate=\"Clients\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"status-container\">\n" +
    "          <div class=\"circle-container\">\n" +
    "            <div class=\"connect-line\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"progress-circle\" ng-class=\"{ 'selected': vm.selectedCategory.name==='Documents'}\"></div>\n" +
    "            <div class=\"connect-line empty\"></div>\n" +
    "          </div>\n" +
    "          <div class=\"status-indicator group-name\" translate=\"Documents\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div>\n" +
    "        <div class=\"collapse-btn\" ng-click=\"isCollapsed = !isCollapsed\">\n" +
    "            <i ng-class=\"{'bento-icon-chevron-medium-down':isCollapsed,'bento-icon-chevron-medium-up':!isCollapsed}\"></i>&nbsp;\n" +
    "            <div ng-if=\"isCollapsed\" translate=\"Show\"></div>\n" +
    "            <div ng-if=\"!isCollapsed\" translate=\"Hide\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"bento-collapse-content\" uib-collapse=\"isCollapsed\">\n" +
    "      <div class=\"setup-container welcome\" ng-if=\"!vm.selectedCategory\">\n" +
    "        <h1 class=\"welcome-header\"><span translate=\"Welcome to\"></span>&nbsp;<span class=\"orange\" translate=\"Onvio\"></span></h1>\n" +
    "        <h2 class=\"welcome-text\" translate=\"Use our worry-free set up guide to set up Onvio at your own pace.\"></h2>\n" +
    "        <button role=\"button\" class=\"btn btn-primary\" ng-click=\"vm.startSetup()\" translate=\"Start Setup\"></button>\n" +
    "      </div>\n" +
    "      <div class=\"setup-container\" ng-if=\"vm.selectedCategory\">\n" +
    "        <div class=\"carousel-btn left\">\n" +
    "          <i role=\"button\" ng-click=\"vm.prevCategory()\" class=\"nav-arrow bento-icon-chevron-medium-left\" ng-class=\"{'nav-arrow-disabled': !vm.selectedCategory.prev}\"></i>\n" +
    "        </div>\n" +
    "        <div class=\"card-container\">\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Staff'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.permGroups===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.permGroups!==true\" class=\"step-number\">1</div>\n" +
    "              <div ng-if=\"vm.completionTracking.permGroups===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-lock\"></i>\n" +
    "            <h1 translate=\"Set up permission groups\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Set permissions first to give yourself access to your modules and make it easy to set up your staff later\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" href=\"/ua/help/{{vm.lang}}/staff/core/setup/video-creating-permission-groups.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\"><i class=\"bento-icon-play\"></i>&nbsp;{{\"How-To Video\" | translate}}</a></div>\n" +
    "            <div>\n" +
    "              <a role=\"button\" href=\"/staff/#/setup/permission-groups\" ng-click=\"vm.markComplete('permGroups')\" class=\"btn btn-default\" translate=\"PERMISSION GROUPS\"></a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Staff'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.rateDesc===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.rateDesc!==true\" class=\"step-number\">2</div>\n" +
    "              <div ng-if=\"vm.completionTracking.rateDesc===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-currency\"></i>\n" +
    "            <h1 translate=\"Add rate descriptions\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Set up is quick and will allow you to easily assign billing rates by service or task\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/setup-staff-rate-descriptions.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"Recommended rate descriptions\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/staff-rate-descriptions\" ng-click=\"vm.markComplete('rateDesc')\" class=\"btn btn-default\" translate=\"STAFF RATE DESCRIPTIONS\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-if=\"vm.setupData.staff !== 'No'\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Staff'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.addStaff===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.addStaff!==true\" class=\"step-number\">3</div>\n" +
    "              <div ng-if=\"vm.completionTracking.addStaff===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-users\"></i>\n" +
    "            <h1 translate=\"Add Staff\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"You can choose what level of access to Onvio you would like to provide each individual staff member\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/video-adding-staff-in-onvio.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\"><i class=\"bento-icon-play\"></i>&nbsp;{{\"How-To Video\" | translate}}</a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/staff\" ng-click=\"vm.markComplete('addStaff')\" class=\"btn btn-default\" translate=\"STAFF SETTINGS\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-if=\"vm.setupData.staff === 'No'\" ng-show=\"vm.selectedCategory.name==='Staff'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'disabled-item': vm.setupData.staff==='No' }\">\n" +
    "              <div class=\"bento-icon-checkmark\" ng-class=\"{ 'disabled-item': vm.setupData.staff==='No' }\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-users\" ng-class=\"{ 'disabled-item': vm.setupData.staff==='No' }\"></i>\n" +
    "            <h1 translate=\"Add Staff\" ng-class=\"{ 'disabled-item': vm.setupData.staff==='No' }\"></h1>\n" +
    "            <div class=\"card-desc\" ng-class=\"{ 'disabled-item': vm.setupData.staff==='No' }\" translate=\"You can choose what level of access to Onvio you would like to provide each individual staff member\"></div>\n" +
    "            <div class=\"card-desc disabled-item-desc\" translate=\"This step has been marked as complete since you do not have any staff\"></div>\n" +
    "            <div class=\"help-link\"><a class=\"btn btn-link\" href=\"/staff/#/setup/staff\" translate=\"Add Staff\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Work Flow'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.engagementTemplates===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.engagementTemplates!==true\" class=\"step-number\">4</div>\n" +
    "              <div ng-if=\"vm.completionTracking.engagementTemplates===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-copy\"></i>\n" +
    "            <h1 translate=\"Set up engagement templates\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Set default information to easily add engagements for clients without duplicating data entry\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/setup-engagement-templates.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"Recommended engagement templates\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/engagement-templates\" ng-click=\"vm.markComplete('engagementTemplates')\" class=\"btn btn-default\" translate=\"ENGAGEMENT TEMPLATES\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Work Flow'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.defineActivities===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.defineActivities!==true\" class=\"step-number\">5</div>\n" +
    "              <div ng-if=\"vm.completionTracking.defineActivities===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-paste\"></i>\n" +
    "            <h1 translate=\"Define activities\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Define what groups of tasks your firm completes for project tracking and time & billing\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/setup-activities.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"Common Activities\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/activities\" ng-click=\"vm.markComplete('defineActivities')\" class=\"btn btn-default\" translate=\"Activities\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-perm=\"ProjectManagement.Projects\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Work Flow'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.projectTemplates===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.projectTemplates!==true\" class=\"step-number\">6</div>\n" +
    "              <div ng-if=\"vm.completionTracking.projectTemplates===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-check\"></i>\n" +
    "            <h1 translate=\"Set up project templates\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Define the specific tasks you complete for your clients so you can start assigning them to your staff\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/projects/set-up-project-template.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"How to set up project templates\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/project-templates\" ng-click=\"vm.markComplete('projectTemplates')\" class=\"btn btn-default\" translate=\"PROJECT TEMPLATES\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-not-perm=\"ProjectManagement.Projects\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Work Flow'\">\n" +
    "            <div class=\"circle-border disabled-item\">\n" +
    "              <div class=\"bento-icon-checkmark disabled-item\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-check disabled-item\"></i>\n" +
    "            <h1 class=\"disabled-item\" translate=\"Set up project templates\"></h1>\n" +
    "            <div class=\"card-desc disabled-item\" translate=\"Define the specific tasks you complete for your clients so you can start assigning them to your staff\"></div>\n" +
    "            <div class=\"upgrade-text\">\n" +
    "                <span translate=\"Upgrade to\"></span> <span class=\"product-name\" translate=\"Project Manager\"></span>\n" +
    "                <div class=\"access-text\"><span translate=\"for access to this feature\"></span></div>\n" +
    "            </div>\n" +
    "<!--             <div class=\"upgrade-link\">\n" +
    "                <a href=\"\" role=\"button\" translate=\"Upgrade now\"></a>\n" +
    "            </div> -->\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Clients'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.customizeClientCenter===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.customizeClientCenter!==true\" class=\"step-number\">7</div>\n" +
    "              <div ng-if=\"vm.completionTracking.customizeClientCenter===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"44\" height=\"36\" viewBox=\"0 0 44 36\">\n" +
    "                  <defs>\n" +
    "                      <path id=\"a\" d=\"M0 35.115V0h44v35.115z\"/>\n" +
    "                  </defs>\n" +
    "                  <g fill=\"none\" fill-rule=\"evenodd\">\n" +
    "                      <mask id=\"b\" fill=\"#fff\">\n" +
    "                          <use xlink:href=\"#a\"/>\n" +
    "                      </mask>\n" +
    "                      <path fill=\"#616169\" d=\"M31.625 13.75a4.125 4.125 0 1 1 0-8.25 4.125 4.125 0 0 1 0 8.25M22 24.75c-3.037 0-5.5-1.847-5.5-4.125S18.963 16.5 22 16.5s5.5 1.847 5.5 4.125-2.463 4.125-5.5 4.125m-11-11a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 1 1 0 5.5m-4.125 5.52a1.396 1.396 0 1 1 0-2.79 1.396 1.396 0 0 1 0 2.79M19.25 2.75a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 1 1 0-5.5M22.132 0C7.992 0 0 9.398 0 16.272c0 10.475 9.398 16.37 17.214 18.301 7.817 1.932 10.758-1.613 10.631-5.698-.152-4.962 2.327-5.027 4.084-4.852C33.685 24.199 44 26.58 44 18.677 44 8.895 36.273 0 22.132 0\" mask=\"url(#b)\"/>\n" +
    "                  </g>\n" +
    "              </svg>\n" +
    "            </div>\n" +
    "            <h1 translate=\"Customize Client Center\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Make Client Center your own by customizing the look and feel to your firm’s unique brand\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/customizing-the-appearance-of-the-client-hub.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"How to customize Onvio\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/themes\" ng-click=\"vm.markComplete('customizeClientCenter')\" class=\"btn btn-default\" translate=\"ONVIO SITE SETUP\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Clients'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.addClients===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.addClients!==true\" class=\"step-number\">8</div>\n" +
    "              <div ng-if=\"vm.completionTracking.addClients===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-user\"></i>\n" +
    "            <h1 translate=\"Add clients\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Add your clients’ information and give them access to Client Center to start seamlessly sharing documents\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/video-adding-clients-in-onvio.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\"><i class=\"bento-icon-play\"></i>&nbsp;{{\"How-To Video\" | translate}}</a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/clients\" ng-click=\"vm.markComplete('addClients')\" class=\"btn btn-default\" translate=\"CLIENTS\"></a></div>\n" +
    "          </div>\n" +
    "          <div class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Clients'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.clientEngagements===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.clientEngagements!==true\" class=\"step-number\">9</div>\n" +
    "              <div ng-if=\"vm.completionTracking.clientEngagements===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-group\"></i>\n" +
    "            <h1 translate=\"Start client engagements\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Add engagements to your clients quickly by using the engagment templates you previously created\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/setup/add-engagement-for-client.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"How to start client engagements\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/setup/clients\" ng-click=\"vm.markComplete('clientEngagements')\" class=\"btn btn-default\" translate=\"CLIENTS\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.folderTemplates===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.folderTemplates!==true\" class=\"step-number\">10</div>\n" +
    "              <div ng-if=\"vm.completionTracking.folderTemplates===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-room\"></i>\n" +
    "            <h1 translate=\"Set up folder templates\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Simplify folder structure setup for each client by creating folder templates \"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/documents/adding-templates.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"Recommended folder templates\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/documents/templates\" ng-click=\"vm.markComplete('folderTemplates')\" class=\"btn btn-default\" translate=\"FOLDER TEMPLATES\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-not-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border disabled-item\">\n" +
    "              <div class=\"bento-icon-checkmark disabled-item\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-room disabled-item\"></i>\n" +
    "            <h1 translate=\"Set up folder templates\" class=\"disabled-item\"></h1>\n" +
    "            <div class=\"card-desc disabled-item\" translate=\"Simplify folder structure setup for each client by creating folder templates \"></div>\n" +
    "            <div class=\"upgrade-text\">\n" +
    "                <span translate=\"Upgrade to\"></span> <span class=\"product-name\" translate=\"Documents\"></span>\n" +
    "                <div class=\"access-text\"><span translate=\"for access to this feature\"></span></div>\n" +
    "            </div>\n" +
    "<!--             <div class=\"upgrade-link\">\n" +
    "                <a href=\"\" role=\"button\" translate=\"Upgrade now\"></a>\n" +
    "            </div> -->\n" +
    "          </div>\n" +
    "          <div bm-if-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.clientFolders===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.clientFolders!==true\" class=\"step-number\">11</div>\n" +
    "              <div ng-if=\"vm.completionTracking.clientFolders===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"32\" viewBox=\"0 0 42 32\">\n" +
    "                  <g fill=\"#616169\" fill-rule=\"evenodd\">\n" +
    "                      <path d=\"M18.652 0L0 .035.084 32 42 31.92l-.074-28.413-19.071.037L18.652 0zM4.2 3.58l12.786-.026 4.2 3.544 16.558-.03.053 21.308-33.53.063L4.2 3.58z\"/>\n" +
    "                      <path d=\"M20.941 8.338l-2.494 2.917 4.116 4.77-10.893.027.008 4.155 10.894-.028-4.099 4.792 2.507 2.902 8.374-9.79z\"/>\n" +
    "                  </g>\n" +
    "              </svg>\n" +
    "            </div>\n" +
    "            <h1 translate=\"Assign folders to clients\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Start creating folders and easily assign them to your clients.\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" target=\"_blank\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/documents/adding-folders.htm?service={{vm.setupData.service}}\" class=\"btn btn-link\" translate=\"How to assign folders\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/documents/all\" ng-click=\"vm.markComplete('clientFolders')\" class=\"btn btn-default\" translate=\"DOCUMENTS\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-not-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border disabled-item\">\n" +
    "              <div class=\"bento-icon-checkmark disabled-item\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"disabled-item\">\n" +
    "              <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"32\" viewBox=\"0 0 42 32\">\n" +
    "                  <g fill=\"#616169\" fill-rule=\"evenodd\">\n" +
    "                      <path d=\"M18.652 0L0 .035.084 32 42 31.92l-.074-28.413-19.071.037L18.652 0zM4.2 3.58l12.786-.026 4.2 3.544 16.558-.03.053 21.308-33.53.063L4.2 3.58z\"/>\n" +
    "                      <path d=\"M20.941 8.338l-2.494 2.917 4.116 4.77-10.893.027.008 4.155 10.894-.028-4.099 4.792 2.507 2.902 8.374-9.79z\"/>\n" +
    "                  </g>\n" +
    "              </svg>\n" +
    "            </div>\n" +
    "            <h1 translate=\"Assign folders to clients\" class=\"disabled-item\"></h1>\n" +
    "            <div class=\"card-desc disabled-item\" translate=\"Start creating folders and easily assign them to your clients.\"></div>\n" +
    "            <div class=\"upgrade-text\">\n" +
    "                <span translate=\"Upgrade to\"></span> <span class=\"product-name\" translate=\"Documents\"></span>\n" +
    "                <div class=\"access-text\"><span translate=\"for access to this feature\"></span></div>\n" +
    "            </div>\n" +
    "<!--             <div class=\"upgrade-link\">\n" +
    "                <a href=\"\" role=\"button\" translate=\"Upgrade now\"></a>\n" +
    "            </div> -->\n" +
    "          </div>\n" +
    "          <div bm-if-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border\" ng-class=\"{ 'completed': vm.completionTracking.uploadDocs===true }\">\n" +
    "              <div ng-if=\"vm.completionTracking.uploadDocs!==true\" class=\"step-number\">12</div>\n" +
    "              <div ng-if=\"vm.completionTracking.uploadDocs===true\" class=\"bento-icon-checkmark\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-filled\"></i>\n" +
    "            <h1 translate=\"Upload documents\"></h1>\n" +
    "            <div class=\"card-desc\" translate=\"Drag and drop documents to folders from your desktop or using Dropbox, Google Drive or Box\"></div>\n" +
    "            <div class=\"help-link\"><a role=\"button\" ng-href=\"/ua/help/{{vm.lang}}/staff/core/documents/sharing-folders.htm?service={{vm.setupData.service}}\" target=\"_blank\" class=\"btn btn-link\" translate=\"How to upload documents\"></a></div>\n" +
    "            <div><a role=\"button\" href=\"/staff/#/documents/clients\" ng-click=\"vm.markComplete('uploadDocs')\" class=\"btn btn-default\" translate=\"CLIENT DOCUMENTS\"></a></div>\n" +
    "          </div>\n" +
    "          <div bm-if-not-perm=\"OnvioDrive.Documents\" class=\"setup-card\" ng-show=\"vm.selectedCategory.name==='Documents'\">\n" +
    "            <div class=\"circle-border disabled-item\">\n" +
    "              <div class=\"bento-icon-checkmark disabled-item\"></div>\n" +
    "            </div>\n" +
    "            <i class=\"card-icon bento-icon-file-filled disabled-item\"></i>\n" +
    "            <h1 translate=\"Upload documents\" class=\"disabled-item\"></h1>\n" +
    "            <div class=\"card-desc disabled-item\" translate=\"Drag and drop documents to folders from your desktop or using Dropbox, Google Drive or Box\"></div>\n" +
    "            <div class=\"upgrade-text\">\n" +
    "                <span translate=\"Upgrade to\"></span> <span class=\"product-name\" translate=\"Documents\"></span>\n" +
    "                <div class=\"access-text\"><span translate=\"for access to this feature\"></span></div>\n" +
    "            </div>\n" +
    "<!--             <div class=\"upgrade-link\">\n" +
    "                <a href=\"\" role=\"button\" translate=\"Upgrade now\"></a>\n" +
    "            </div> -->\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"carousel-btn\">\n" +
    "          <i role=\"button\" ng-click=\"vm.nextCategory()\" ng-disabled=\"vm.selectedCategory.next\" class=\"nav-arrow bento-icon-chevron-medium-right\" ng-class=\"{'nav-arrow-disabled': !vm.selectedCategory.next}\"></i>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<!-- <button ng-click=\"vm.resetQuestionairre()\">RESET QUESTION</button>\n" +
    "<button ng-click=\"vm.deleteCompletionPref()\">DELETE COMPLETION TRACKING</button>\n" +
    " -->\n" +
    "");
}]);
